import { LightningElement, api } from "lwc";

export default class Link extends LightningElement {
  @api href;
  @api title;
  @api label;
}
